import { ActionTypes } from '../constants'

const profile = (state = {
  submitting: false,
  error: null,
  validationErrors: null
}, action) => {
  switch (action.type) {

  case ActionTypes.UPDATE_PROFILE_REQUEST:
    return { ...state, submitting: true, error: null, validationErrors: null }

  case ActionTypes.UPDATE_PROFILE_FAILURE:
    var { error, error: { response } } = action
    return {
      ...state,
      submitting: false,
      error: /(409|422)/.test(response.status) ? null : error,
      // 406 - not_acceptable для того, чтобы остаться в форме с ошибками
      validationErrors: /(406|409|422)/.test(response.status) ? error.response.data : null
    }

  case ActionTypes.UPDATE_PROFILE_SUCCESS:
    return { ...state, submitting: false }

  default:
    return state
  }
}

export default profile
